/* eslint-disable */
import { Grid, Typography } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import AppsIcon from '@material-ui/icons/Apps';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import cn from 'classnames';
import { isAccountPage } from '../../Pages/Account/Account.page.route';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import { ENTRY_PORTAL_CUSTOMER_NAME } from '../../Entries/PortalCustomer/PortalCustomer.entry.constants';
import { ENTRY_PORTAL_OPERATIONS_NAME } from '../../Entries/PortalOperations/PortalOperations.entry.constants';
import { createDeliveriesPageLink, isDeliveriesPage } from '../../Pages/Deliveries/Deliveries.page.route';
import { isHelpPage } from '../../Pages/Help/Help.page.route';
import { createLoginPageLink, isLoginPage } from '../../Pages/Login/Login.page.route';
import { createOrdersPageLink, isOrdersPage } from '../../Pages/Orders/Orders.page.route';
import { createPlaceOrderPageLink } from '../../Pages/PlaceOrder/PlaceOrder.page.route';
import { createDashboardPageLink } from '../../Pages/Dashboard/Dashboard.page.route';
import authCurrentSelector from '../../State/Store/Auth/Selectors/AuthCurrent.selector';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_NOTIFICATIONS_DIALOG_OPEN, UI_NOTIFICATIONS_SETTINGS_DIALOG_OPEN } from '../../State/Store/UI/UI.types';
import envGet from '../../Support/Env/Get/EnvGet.support';
import themeAlignEnd from '../../Support/Theme/AlignEnd/ThemeAlignEnd.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import NotificationsModal from '../NotificationsModal/NotificationsModal.component';
import ProfilePic from '../ProfilePic/ProfilePic.component';
import UserMenu from '../UserMenu/UserMenu.component';
import './Navbar.component.i18n';
import NavbarPropTypes from './Navbar.component.props';
import navbarStyles from './Navbar.component.styles';
import NotificationActionCreatorsMapping from 'State/Store/Notification/NotificationActionCreatorCenter';
import createNotificationSelector from 'State/Store/Notification/Notification.selector';
import SettingsIcon from '@material-ui/icons/Settings'
import { PROFILE_PAGE_PATH } from '../../Pages/Profile/Profile.page.route'

/**
 * NavbarComponent
 * @export
 * @class NavbarComponent
 * @extends {React.Component<NavbarComponentComposedProps, NavbarComponentState>}
 */
export class NavbarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<NavbarComponentProps>}
   * @memberof NavbarComponent
   */
  static defaultProps = {
    hideLogo: false,
    hideUserMenu: true,
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Navbar`}
   * @memberof NavbarComponent
   */
  static displayName = `Navbar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof NavbarComponent
   */
  static propTypes = NavbarPropTypes;

  /**
   * Data specific to the `<NavbarComponent />` instance
   * @type {NavbarComponentState}
   * @memberof NavbarComponent
   */
  state = {
    appsMenuAnchor: null,
    notificationsOpen: false,
    userMenuAnchor: null,
  };

  /**
   * Close the apps menu
   * @returns {void} void
   * @memberof NavbarComponent
   */
  handleAppsMenuClose = () => {
    this.setState({
      appsMenuAnchor: null,
    });
  };

  /**
   * Open the apps menu
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof NavbarComponent
   */
  handleAppsMenuOpen = (event) => {
    this.setState({
      appsMenuAnchor: event.currentTarget,
    });
  };

  /**
   * Toggle hiding and showing the sidebar
   * @returns {void} void
   * @memberof NavbarComponent
   */
  handleSidebarToggle = () => {
    const { actions } = this.props;
    actions.sidebarToggle();
  };

  /**
   * Hide the user menu
   * @returns {void} void
   * @memberof NavbarComponent
   */
  handleUserMenuClose = () => {
    this.setState({
      userMenuAnchor: null,
    });
  };

  /**
   * Show the user menu
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof NavbarComponent
   */
  handleUserMenuOpen = (event) => {
    this.setState({
      userMenuAnchor: event.currentTarget,
    });
  };

  /**
   * Render the apps menu
   * @returns {React.Component} The apps menu
   * @memberof NavbarComponent
   */
  renderAppsMenu = () => {
    if (!this.shouldShowAppsMenu()) {
      return null;
    }
    const { classes, locale, match } = this.props;
    const { appsMenuAnchor } = this.state;
    const isAppsMenuOpen = appsMenuAnchor !== null;
    const horizontal = themeAlignEnd(locale.direction);
    return (
      <React.Fragment>
        <Tooltip title={<I18n>Navbar.AppsMenu.Tooltip</I18n>}>
          <IconButton
            aria-haspopup="true"
            aria-owns={isAppsMenuOpen ? `navbarAppsMenu` : null}
            className={cn(classes.menuButton)}
            color="inherit"
            onClick={this.handleAppsMenuOpen}
          >
            <AppsIcon />
          </IconButton>
        </Tooltip>
        <Popover
          anchorEl={appsMenuAnchor}
          anchorOrigin={{
            horizontal,
            vertical: `bottom`,
          }}
          id="navbarAppsMenu"
          onClose={this.handleAppsMenuClose}
          open={isAppsMenuOpen}
          transformOrigin={{
            horizontal,
            vertical: `bottom`,
          }}
        >
          <div className={cn(classes.appsMenu, classes.menuWidth)}>
            <List>
              <ListItem {...(isDeliveriesPage(match) ? {} : { button: true, component: Link, to: createDeliveriesPageLink() })}>
                <ListItemIcon>
                  <LocalShippingIcon />
                </ListItemIcon>
                <ListItemText>
                  <I18n>Navbar.AppsMenu.Deliveries</I18n>
                </ListItemText>
                <ListItemSecondaryAction>
                  <ExitToAppIcon />
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem {...(isOrdersPage(match) ? {} : { button: true, component: Link, to: createOrdersPageLink() })}>
                <ListItemIcon>
                  <InsertDriveFileIcon />
                </ListItemIcon>
                <ListItemText>
                  <I18n>Navbar.AppsMenu.Orders</I18n>
                </ListItemText>
                <ListItemSecondaryAction>
                  <ExitToAppIcon />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
          </div>
        </Popover>
      </React.Fragment>
    );
  };

  /**
   * Render the navbar extensions
   * @returns {React.Component} Extensions menu
   * @memberof NavbarComponent
   */
  renderExtensions = () => {
    const { classes, large, checkingNotifications, hasUnreadNotifications, renderExtensions, match, width, location } = this.props;
    let icon = null;
    if (!checkingNotifications) {
      icon = hasUnreadNotifications ? <NotificationsActiveIcon className={classes.activeIcon} /> : <NotificationsIcon className={classes.opacity05} />;
    }

    return (
      <div className={cn(large && classes.extensions)}>
        {createPlaceOrderPageLink() !== match.path && createDashboardPageLink() !== match.path && isWidthUp(`sm`, width) && (
          <Button className={classes.boxShadow0} component={Link} to={createPlaceOrderPageLink()} variant="contained" size="small" color="primary">
            <AddIcon className={classes.addIcon} /> Place an order
          </Button>
        )}
        {location.pathname === PROFILE_PAGE_PATH && <IconButton className={classes.settingsButton} color="inherit" data-id="navBarNotificationIconButton" onClick={this.openNotificationsSettings} ><SettingsIcon className={classes.opacity05} color="inherit" data-id="navBarNotificationSettingsIconButton"/>
        </IconButton>}
        <IconButton color="inherit" data-id="navBarNotificationIconButton" onClick={this.openNotifications}>
          {icon}
        </IconButton>
        {renderExtensions}
      </div>
    );
  };

  /**
   * Opens notifications modal
   * @returns {void} void
   * @memberof NavbarComponent
   */
   openNotifications = () => {
    const { actions } = this.props;

    actions.uiTriggered({ type: UI_NOTIFICATIONS_DIALOG_OPEN });
    actions.openNotificationModal();
    return;
  };

  /**
   * Opens notifications modal
   * @returns {void} void
   * @memberof NavbarComponent
   */
  openNotificationsSettings = () => {
    const { actions } = this.props;

    actions.uiTriggered({ type: UI_NOTIFICATIONS_SETTINGS_DIALOG_OPEN });
    actions.toggleNotificationSettings();
    actions.openNotificationModal();
    return;
  };

  /**
   * Render the login button
   * @returns {React.Component | null} The login button
   * @memberof NavbarComponent
   */
  renderLoginButton = () => {
    const { match } = this.props;
    // Hide the login button on the login and help page
    if (isLoginPage(match)) {
      return null;
    }
    if (isHelpPage(match)) {
      return null;
    }
    return (
      <Button color="primary" component={Link} to={createLoginPageLink()} variant="outlined">
        <I18n>Navbar.ListItem.Login</I18n>
      </Button>
    );
  };

  /**
   * Render the user menu
   * @returns {React.Component} The user menu
   * @memberof NavbarComponent
   */
  renderUserMenu = () => {
    const { hideUserMenu } = this.props;
    if (hideUserMenu) {
      return null;
    }
    const { auth, classes, locale } = this.props;
    const { userMenuAnchor } = this.state;
    const isUserMenuOpen = userMenuAnchor !== null;
    const horizontal = themeAlignEnd(locale.direction);
    return (
      <React.Fragment>
        <IconButton
          aria-haspopup="true"
          aria-label="user-profile-pic"
          aria-owns={isUserMenuOpen ? `navbarUserMenu` : null}
          color="inherit"
          onClick={this.handleUserMenuOpen}
        >
          <ProfilePic user={auth.user} />
        </IconButton>
        <Popover
          anchorEl={userMenuAnchor}
          anchorOrigin={{
            horizontal,
            vertical: `bottom`,
          }}
          id="navbarUserMenu"
          onClose={this.handleUserMenuClose}
          open={isUserMenuOpen}
          transformOrigin={{
            horizontal,
            vertical: `bottom`,
          }}
        >
          <div className={cn(classes.userMenu, classes.menuWidth)}>
            <UserMenu />
          </div>
        </Popover>
      </React.Fragment>
    );
  };

  /**
   * Determine whether or not to show the apps menu
   * @returns {boolean} Whether or not to show the apps menu
   * @memberof NavbarComponent
   */
  shouldShowAppsMenu = () => {
    const { entry } = this.props;
    if (entry.name === ENTRY_PORTAL_CUSTOMER_NAME) {
      return false;
    }
    if (entry.name === ENTRY_PORTAL_OPERATIONS_NAME) {
      return false;
    }
    return true;
  };

  /**
   * Closes notification modal and marks notifications as read
   * @returns {void} void
   * @memberof NavbarComponent
   */
  closeNotificationsModal = async () => {
    const { services, resetNotifications } = this.props;
    this.setState({ notificationsOpen: false });
    await services.notificationService.markAllRead();
    resetNotifications();
    return;
  };

  /**
   * shows notifications settings
   * @returns {void} void
   * @memberof NavbarComponent
   */
  showSettings = async () => {
    // TODO add analytics
    this.setState({ settingsOpen: true });
    return;
  };

  /**
   * hides notifications settings
   * @returns {void} void
   * @memberof NavbarComponent
   */
  hideSettings = async () => {
    // TODO add analytics
    this.setState({ settingsOpen: false });
    return;
  };

  renderHeading = () => {
    const { large, defaultLanguageHeading, headingData, heading, width } = this.props;
    const isSmall = isWidthDown(`sm`, width);
    // condition below for "variant" left for now as it tends to change almost daily by designers
    const LanguageHeading = defaultLanguageHeading && <Typography variant={isSmall ? `h6` : `h6`}>{defaultLanguageHeading}</Typography>;
    const I18NHeading = (
      <I18n color="inherit" data={headingData} variant={isSmall ? `h6` : `h6`}>
        {heading}
      </I18n>
    );
    // XXX: Only hide heading for orders page and when it's width is not sm
    if (!isSmall && heading === `OrdersPage.PageTitle`) {
      return null;
    }
    return large || LanguageHeading || I18NHeading;
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<NavbarComponent />`
   * @memberof NavbarComponent
   */
  render() {
    const { auth, classes, large, hideMenuIcon, match } = this.props;
    return (
      <div className={cn(classes.root, large && classes.largeNavBar)}>
        <AppBar className={cn(classes.appBar)} color="default" position="absolute">
          <Toolbar classes={{ root: cn(large && classes.largeNavBar, hideMenuIcon || (large ? classes.largePadding : classes.smallPadding)) }}>
            {!hideMenuIcon && (
              <IconButton className={cn(large && classes.burgerButton, classes.headingIndent)} color="inherit" onClick={this.handleSidebarToggle}>
                <MenuIcon />
              </IconButton>
            )}
            {isAccountPage(match) ? <span data-mf-replace-inner={MFSDR}>{this.renderHeading()}</span> : this.renderHeading()}
            <span className={cn(classes.spacer)} />
            {auth ? (
              <React.Fragment>
                {this.renderAppsMenu()}
                {this.renderExtensions()}
                {this.renderUserMenu()}
              </React.Fragment>
            ) : (
              <React.Fragment>{this.renderLoginButton()}</React.Fragment>
            )}
          </Toolbar>
          <Divider />
        </AppBar>
        <div className={cn(classes.offset)} />
      </div>
    );
  }
}

/** @type {React.ComponentClass<NavbarComponentProps>} */
const Navbar = compose(
  withEntries,
  withRouter,
  withServices,
  withWidth(),
  withStyles(themeCreateInjectableStyles(navbarStyles), { withTheme: true }),
  connect(
    (state) => ({
      auth: authCurrentSelector(state),
      locale: i18nLocaleSelector(state),
      notificationStore: createNotificationSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
          ...uiActionCreators,
          openNotificationModal: NotificationActionCreatorsMapping.openNotificationModal,
          toggleNotificationSettings: NotificationActionCreatorsMapping.toggleNotificationSettings,
        },
        dispatch,
      ),
    }),
  ),
)(NavbarComponent);

export default Navbar;
